import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { ButtonCSSStyle } from './buttoncss';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { ButtonView } from './buttonview';
import { UIComponentCSSStyle } from '../uicomponentcss';


export interface ButtonProps extends UIComponentProps
{
    label: string;
    style: ButtonCSSStyle;
    onClick():void;
}
export interface ButtonState extends UIComponentState
{
    label: string;
    style: ButtonCSSStyle;
}

export interface ButtonHandler extends UIComponentHandler
{
    
}

export class ButtonComponent extends UIComponentImpl<ButtonProps, ButtonState, UIDataModel>
{
    constructor(props: ButtonProps)
    {
        super(props);

        this.state = {label: props.label, style: props.style};
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ButtonView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.state.style;
    }

    UNSAFE_componentWillReceiveProps(nextProps: ButtonProps)
    {
        this.setState({label: nextProps.label, style: nextProps.style});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/button/buttoncomponent.tsx